import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  Button,
  Box,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import CalendarExtend from "../../../src/assests/images/CalendarExtends.svg";
import closeIcon from "../../../src/assests/images/close-circle.svg";
import Warning from "../../../src/assests/images/warning-2.svg";
import UploadScreen from "./UploadScreen";
import { extendenddate } from "./api";
import { getToken } from "../../utils/utils";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import { useNavigate } from "react-router-dom";
const ExtendsDate = ({
  open,
  onClose,
  cohorttitel,
  cohortassigneddate,
  cohortendDate,
  cohortendDate22,
  taskid,
}: {
  open: boolean;
  onClose: () => void;
  cohorttitel: string;
  cohortassigneddate: string;
  cohortendDate22: string
  cohortendDate: string;
  taskid: string;
}) => {
  const [value, setValue] = useState<number>(6);
  const [secondPopupOpen, setSecondPopupOpen] = useState(false);

  const handleValueChange = (delta: number) => {
    setValue((prev) => Math.max(prev + delta, 0));
  };
  const token = getToken();
  const { showAlert } = useAlert();
  console.log(taskid, "ggggggggggdddddddd");
  console.log(cohortendDate, "cohortassigneddatessss")

  const navigate = useNavigate();
  const handleSecondPopupOpen = async () => {
    console.log("khghghhghghghhghggh");
    showAlert("Successfully", "info");
    const reqBody = {
      task_id: taskid,
      days: String(value),
      start_date: cohortassigneddate

    };

    try {
      const verificationResponse = await extendenddate(reqBody, token);
      setSecondPopupOpen(true);
      console.log(verificationResponse.data.success, "verificationResponsessss")

      onClose();

      showAlert("Extend date successfully!", "success");
      if (verificationResponse.data.success === true) {
        setTimeout(() => window.location.reload(), 100);
      }
    } catch (error) {
      console.error("Error in extendenddate:", error);
      showAlert("An error occurred while brand", "error");
    }
  };

  const handleSecondPopupClose = () => {
    setSecondPopupOpen(false);
  };
  console.log(
    cohortendDate,
    "cohortendDatecohortendDatecohortendDatecohortendDate"
  );
  console.log(value, "valuevaluevaluevaluevalue");
  console.log(taskid, "taskidtaskidtaskid");
  return (
    <>
      <Dialog open={open} onClose={onClose} sx={{
        borderRadius: "10px",
        "& .MuiDialog-paper": { borderRadius: "10px", }
      }}>
        <DialogTitle sx={{ width: "540px !important", borderRadius: "20px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #d0d0d0",
              paddingBottom: "15px",
              marginBottom: "10px",
            }}
          >
            <Box>
              <Typography sx={{ display: "flex" }}>
                <img src={CalendarExtend} alt="Create Cohort" />
                <Typography
                  sx={{
                    marginLeft: "10px",
                    marginTop: "10px",
                    fontWeight: "600",
                  }}
                >
                  Extend Task End Date
                </Typography>
              </Typography>
            </Box>
            <Box>
              <Button
                onClick={onClose}
                color="primary"
                sx={{
                  borderRadius: "50%",
                  color: "#000",
                  fontSize: "10px",
                  position: "relative",
                  right: "-20px",
                }}
              >
                <img src={closeIcon} alt="close" />
              </Button>
            </Box>
          </Box>

          {/* Task Details */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              paddingTop: "20px",
              width: "100%",
              gap: "50px"
            }}
          >
            <Typography variant="body2" color="text.secondary">
              <Typography sx={{ fontSize: "16px", color: "#494A4B" }}>
                Task Name
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px", fontWeight: "700", color: "#282829", whiteSpace: "nowrap",       // Prevents text from wrapping
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                }}
              >
                {cohorttitel}
              </Typography>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <Typography sx={{ fontSize: "16px", color: "#494A4B" }}>
                Assigned Date
              </Typography>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "700", color: "#282829" }}
              >
                {cohortassigneddate}
              </Typography>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <Typography sx={{ fontSize: "16px", color: "#494A4B" }}>
                Duration
              </Typography>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "700", color: "#282829" }}
              >
                {cohortendDate}
              </Typography>
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              marginTop: "30px",
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#333", fontSize: "16px" }}
            >
              No of Days
            </Typography>
            <TextField
              value={value}
              onChange={(e) => setValue(Number(e.target.value))}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 0 }}
                    >
                      <Box
                        sx={{
                          width: "8px",
                          height: "8px",
                          border: "solid #666",
                          borderWidth: "0 2px 2px 0",
                          transform: "rotate(-135deg)",
                          marginBottom: "2px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleValueChange(1)}
                      />
                      <Box
                        sx={{
                          width: "8px",
                          height: "8px",
                          border: "solid #666",
                          borderWidth: "0 2px 2px 0",
                          transform: "rotate(45deg)",
                          cursor: "pointer",
                        }}
                        onClick={() => handleValueChange(-1)}
                      />
                    </Box>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                min: 0,
                style: {
                  textAlign: "left",
                },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor: "#f9fbfc",
                  border: "none",
                  "& fieldset": {
                    borderColor: "#e0e0e0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#c7c7c7",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#0F7CAD",
                  },
                },
                width: "200px",
                height: "50px",
              }}
            />
          </Box>

          <Box sx={{ display: "flex", marginTop: "30px", background: "#F5E69666", padding: "0 10px 10px" }}>
            <img src={Warning} alt="warning" />
            <Typography
              sx={{
                fontSize: "14",
                color: "#282829",
                fontWeight: "400",
                paddingLeft: "10px",
                marginTop: "20px",
              }}
            >
              Note: Any extension of active task will trigger an email to
              project owner abc@pmintl.com for approval.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "30px",
              paddingBottom: "0px",
            }}
          >
            <Button
              sx={{
                background: "#d0d0d0",
                color: "#fff",
                textTransform: "capitalize",
                padding: "8px 20px",
                borderRadius: "10px",
                width: "50%",
              }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              sx={{
                background: "#C8172F",
                color: "#fff",
                textTransform: "capitalize",
                marginLeft: "20px",
                padding: "8px 20px",
                borderRadius: "10px",
                alignItems: "center",
                width: "50%",
              }}
              onClick={handleSecondPopupOpen}
            >
              Submit
            </Button>
          </Box>
        </DialogTitle>
      </Dialog>

      {/* <UploadScreen open={secondPopupOpen} onClose={handleSecondPopupClose} /> */}
    </>
  );
};

export default ExtendsDate;
